import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';
import { isFalsy } from 'utility-types';
import { TipoExpedienteService } from '@services/tipoExpediente/tipoExpediente.service';
import { EstadoExpedienteService } from '@services/estadoExpediente/estadoExpediente.service';
import { CreateExpedienteRequest } from '@models/expediente/createExpedienteRequest.model';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { EstadoProcesalService } from '@services/estadoProcesal/estado-procesal.service';
import { provideNgxMask } from 'ngx-mask';
import { EstadosExpediente, EstadosExpedientePerito, EstadosProcesal, TiposMoneda } from '@models/base/identificadores.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';
import { BuscarCasoComponent } from '@views/busquedas/buscar-caso/buscar-caso.component';
import { SpinnerComponent } from '@views/spinner/spinner.component';
import { SharedModule } from '@modules/shared.module';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelComponent } from '@component/button-cancel/button-cancel.component';
import { CasoDto } from '@models/caso/casoDto.model';
import { CasoService } from '@services/caso/caso.service';
import { BtnNuevoCasoComponent } from '@views/casos/btn-nuevo-caso/btn-nuevo-caso.component';
import { DtoBase } from '@models/base/dtoBase.model';
import { CasoDetailCardComponent } from '@views/casos/caso-detail-card/caso-detail-card.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { TipoMonedaDto } from '@models/tipoMoneda/tipoMoneda.model';
import { TipoMonedaService } from '@services/tipoMoneda/tipoMoneda.service';
import { SelectJuzgadoComponent } from '@views/juzgados/select-juzgado/select-juzgado.component';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  standalone: true,
  imports: [
    MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule,
    NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule,
    MatInputModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule,
    MatTooltipModule, MatPaginatorModule, MatRippleModule, MatStepperModule, GoBackAndTitleComponent,
    BuscarCasoComponent, MatCardModule, MatNativeDateModule, AppRolesDirective, ButtonAddComponent,
    ButtonCancelComponent, BtnNuevoCasoComponent, CasoDetailCardComponent, SelectUsuariosEmpresaComponent,ButtonCancelComponent,RouterModule,SelectJuzgadoComponent,MatChipsModule
  ],
  selector: 'app-form-expediente-create',
  templateUrl: './form-expediente-create.component.html',
  styleUrls: ['./form-expediente-create.component.css'],
})
export class FormExpedienteCreateComponent implements OnInit {
  formBuilder: FormBuilder = new FormBuilder;

  // FormGroups separados para cada step
  informacionBasicaForm!: FormGroup;
  detallesExpedienteForm!: FormGroup;
  informacionAdicionalForm!: FormGroup;
  descripcionForm!: FormGroup;

  // Datos para dropdowns
  estadosExpedientes!: BaseDto[];
  estadosExpedientesPerito!: BaseDto[];
  tiposExpedientes!: BaseDto[];
  juzgados!: JuzgadoDto[];
  estadosProcesal!: BaseDto[];
  casoDto!: CasoDto;
  tiposMoneda!: BaseDto[];
  mostrarClave = false;
  isLoading!: boolean;

  // Valores iniciales opcionales
  jurisdiccionInicial: BaseDto | null = null;
  fueroInicial: BaseDto | null = null;
  juzgadoInicial: JuzgadoDto | null = null;

  // Selección actual
  seleccionJuzgadoActual: {
    jurisdiccion: BaseDto | null,
    fuero: BaseDto | null,
    juzgado: JuzgadoDto | null
  } | null = null;

  constructor(
    private expedienteService: ExpedienteService,
    private tipoExpedienteService: TipoExpedienteService,
    private estadoExpedienteService: EstadoExpedienteService,
    private juzgadoService: JuzgadoService,
    private tipoMonedaService: TipoMonedaService,

    private router: Router,
    private route: ActivatedRoute,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private casoService: CasoService,
    private estadoProcesalService: EstadoProcesalService
  ) { }

  ngOnInit(): void {
    this.initializeForms();
    this.loadInitialData();
    this.handleRouteParams();
  }

  private initializeForms(): void {
    // Formulario Step 1: Información Básica
    this.informacionBasicaForm = this.formBuilder.group({
      Caratula: ['', [Validators.required, Validators.maxLength(200)]],
      IdentificadorUnico: ['', [Validators.required, Validators.maxLength(50)]],
      Caso: ['', [Validators.required]],
      SeparadorCaratula: [''],
      Sufijo: [''],
      Bis: [''],
      Demanda: ['', [Validators.required]],
      Demandado: ['', [Validators.required]],
      Causa: ['', [Validators.required]]
    });

    // Formulario Step 2: Detalles del Expediente
    this.detallesExpedienteForm = this.formBuilder.group({
      Numero: [''],
      TipoExpediente: ['', [Validators.required]],
      EstadoExpedientes: [''],
      EstadoProcesal: ['', [Validators.required]],
      AsignadoA: [''],
    });

    // Formulario Step 3: Información Adicional
    this.informacionAdicionalForm = this.formBuilder.group({
      Ubicacion: [''],
      Juzgado: ['', [Validators.required]],
      FechaIngresoMEU: [''],
      ClaveExpediente: [''],
      UrlGestion: [''],
      MontoDemanda: [''],
      IdTipoMonedaMontoDemanda: [''],
    });

    // Formulario Step 4: Descripción
    this.descripcionForm = this.formBuilder.group({
      Descripcion: ['', [Validators.maxLength(2000)]]
    });

    // Valores por defecto
    this.detallesExpedienteForm.patchValue({
      EstadoExpedientes: EstadosExpediente.EnTramite,
      EstadoProcesal: EstadosProcesal.AdmisiónDemanda,
    });
    this.informacionAdicionalForm.patchValue({
      IdTipoMonedaMontoDemanda: TiposMoneda.PesoArgentino,
    });
  }

  private loadInitialData(): void {
    this.getAllEstadosExpediente();
    this.getAllTiposExpedientes();
    this.getAllEstadosProcesal();
    this.getAllTiposMoneda();
  }

  private handleRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['idCaso'];
      if (id) {
        this.casoGetById(id);
      }
    });
  }

  onSubmit(): void {
    if (!this.isFormValid()) {
      this.snackBar.showError('Por favor complete todos los campos requeridos', 'Error');
      return;
    }
    this.isLoading =true

    const createExpedienteRequest: CreateExpedienteRequest = this.setCreateExpedienteRequest();
    this.spinner.show("spExpediente");

    this.expedienteService.create(createExpedienteRequest)
      .subscribe({
        next: (data) => {
          this.spinner.hide("spExpediente");
          this.snackBar.showSuccess("Se agregó el expediente correctamente", "");
          this.router.navigate(["/expedientes/" + data.id]);
          this.isLoading =false
        },
        error: (error) => {
          this.spinner.hide("spExpediente");
          this.snackBar.showError(error, "Error");
          this.isLoading =false
        }
      });
  }

  onJuzgadoSeleccionado(seleccion: {
    jurisdiccion: BaseDto | null,
    fuero: BaseDto | null,
    juzgado: JuzgadoDto | null
  }): void {
    this.seleccionJuzgadoActual = seleccion;

    // Ejemplo: Si se seleccionó un juzgado, hacer algo
    if (seleccion.juzgado) {
     this.informacionAdicionalForm.get('Juzgado')?.setValue(this.seleccionJuzgadoActual?.juzgado?.id);
    }
    else
    this.informacionAdicionalForm.get('Juzgado')?.setValue(null)
  }

  isFormValid(): boolean {
    return this.informacionBasicaForm.valid &&
      this.detallesExpedienteForm.valid &&
      this.informacionAdicionalForm.valid &&
      this.descripcionForm.valid;
  }

  getAllEstadosExpediente(): void {
    this.spinner.show("spEstadosExpediente");
    this.estadoExpedienteService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spEstadosExpediente");
          this.estadosExpedientes = data;
        },
        error: (error) => {
          this.spinner.hide("spEstadosExpediente");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  getAllEstadosProcesal(): void {
    this.spinner.show("spEstadosProcesal");
    this.estadoProcesalService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spEstadosProcesal");
          this.estadosProcesal = data;
        },
        error: (error) => {
          this.spinner.hide("spEstadosProcesal");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  casoGetById(id: number): void {
    this.spinner.show("spExpediente");
    this.casoService.getById(id)
      .subscribe({
        next: (data) => {
          this.spinner.hide("spExpediente");
          this.setCasoDto(data);
          this.casoDto = data;
          this.informacionBasicaForm.patchValue({ Caso: data.id });
        },
        error: (error) => {
          this.spinner.hide("spExpediente");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  getAllTiposExpedientes(): void {
    this.spinner.show("spTiposExpedientes");
    this.tipoExpedienteService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spTiposExpedientes");
          this.tiposExpedientes = data;
        },
        error: (error) => {
          this.spinner.hide("spTiposExpedientes");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  getAllTiposMoneda(): void {
    this.spinner.show("spTiposMoneda");
    this.tipoMonedaService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spTiposMoneda");
          this.tiposMoneda = data;
        },
        error: (error) => {
          this.spinner.hide("spTiposMoneda");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  onCreadoPorSeleccionado(usuarioEmpresa: any) {
    this.detallesExpedienteForm.get('AsignadoA')?.setValue(usuarioEmpresa?.usuario?.id);
  }

  toggleMostrarClave() {
    this.mostrarClave = !this.mostrarClave;
  }

  setCreateExpedienteRequest(): CreateExpedienteRequest {
    const createExpedienteRequest = new CreateExpedienteRequest();

    // Información básica
    createExpedienteRequest.caratula = this.informacionBasicaForm.get('Caratula')?.value;
    createExpedienteRequest.identificadorUnico = this.informacionBasicaForm.get('IdentificadorUnico')?.value;
    createExpedienteRequest.idCaso = this.informacionBasicaForm.get('Caso')?.value;
    createExpedienteRequest.separadorCaratula = this.informacionBasicaForm.get('SeparadorCaratula')?.
      value;
    createExpedienteRequest.sufijo = this.informacionBasicaForm.get('Sufijo')?.value;
    createExpedienteRequest.bis = this.informacionBasicaForm.get('Bis')?.value;
    createExpedienteRequest.demanda = this.informacionBasicaForm.get('Demanda')?.value;
    createExpedienteRequest.demandado = this.informacionBasicaForm.get('Demandado')?.value;
    createExpedienteRequest.causa = this.informacionBasicaForm.get('Causa')?.value;

    // Detalles del expediente
    createExpedienteRequest.numero = this.detallesExpedienteForm.get('Numero')?.value;
    createExpedienteRequest.idTipoExpediente = this.detallesExpedienteForm.get('TipoExpediente')?.value;
    createExpedienteRequest.idEstadoExpediente = this.detallesExpedienteForm.get('EstadoExpedientes')?.value;
    createExpedienteRequest.idEstadoProcesal = this.detallesExpedienteForm.get('EstadoProcesal')?.value;
    createExpedienteRequest.asignadoA = this.detallesExpedienteForm.get('AsignadoA')?.value;


    // Información adicional
    createExpedienteRequest.ubicacion = this.informacionAdicionalForm.get('Ubicacion')?.value;

    createExpedienteRequest.idJuzgado = this.informacionAdicionalForm.get('Juzgado')?.value;
    createExpedienteRequest.fechaIngresoMEU = this.informacionAdicionalForm.get('FechaIngresoMEU')?.value;
    createExpedienteRequest.claveExpediente = this.informacionAdicionalForm.get('ClaveExpediente')?.value;
    createExpedienteRequest.urlGestion = this.informacionAdicionalForm.get('UrlGestion')?.value;
    createExpedienteRequest.montoDemanda = isFalsy(this.informacionAdicionalForm.get('MontoDemanda')?.value) ? 0 : this.informacionAdicionalForm.get('MontoDemanda')?.value;
    createExpedienteRequest.idTipoMonedaMontoDemanda = isFalsy(this.informacionAdicionalForm.get('IdTipoMonedaMontoDemanda')?.value) ? 0 : this.informacionAdicionalForm.get('IdTipoMonedaMontoDemanda')?.value;


    // Descripción
    createExpedienteRequest.descripcion = this.descripcionForm.get('Descripcion')?.value;

    return createExpedienteRequest;
  }

  selectCaso(casoDto: BaseDto) {
    this.casoGetById(casoDto.id)
  }
  setCasoDto(casoDto: CasoDto): void {
    if (casoDto && typeof casoDto.caratula === 'string') {
      this.casoDto = casoDto;
      this.informacionBasicaForm.patchValue({ Caratula: casoDto.caratula });

      const cadena = casoDto.caratula?.toUpperCase();
      const cPos = cadena.indexOf("C/ ");
      const sPos = cadena.indexOf(" S/ ");

      if (cPos !== -1 && sPos !== -1 && cPos < sPos) {
        const demanda = cadena.substring(0, cPos).trim();
        const demandado = cadena.substring(cPos + 3, sPos).trim();
        const causa = cadena.substring(sPos + 3).trim();

        this.detallesExpedienteForm.patchValue({
          Demanda: demanda,
          Demandado: demandado,
          Causa: causa
        });
      } else {
        this.detallesExpedienteForm.patchValue({
          Demanda: '',
          Demandado: '',
          Causa: ''
        });
      }
    } else {
      this.informacionBasicaForm.patchValue({ Caratula: '' });
      this.detallesExpedienteForm.patchValue({
        Demanda: '',
        Demandado: '',
        Causa: ''
      });
    }
  }

/**
 * Verifica si el formulario está completo para mostrar alertas
 */
isFormularioCompleto(): boolean {
  return this.informacionBasicaForm.valid &&
         this.detallesExpedienteForm.valid &&
         this.informacionAdicionalForm.valid;
}

/**
 * Obtiene el nombre del juzgado de forma más robusta
 */
getJuzgadoName(juzgadoId: any): string {
  if (!juzgadoId) return 'No seleccionado';

  // Si ya tienes el objeto juzgado completo desde el selector
  if (this.seleccionJuzgadoActual?.juzgado) {
    return this.seleccionJuzgadoActual?.juzgado.descripcion || 'No especificado';
  }

  // Si solo tienes el ID, buscar en la lista (si la tienes)
  // const juzgado = this.juzgados?.find(j => j.id === juzgadoId);
  // return juzgado?.descripcion || 'No especificado';

  return 'No especificado';
}

/**
 * Obtiene el nombre del tipo de expediente
 */
getTipoExpedienteName(tipoId: any): string {
  if (!tipoId) return 'No seleccionado';
  const tipo = this.tiposExpedientes?.find(t => t.id === tipoId);
  return tipo?.descripcion || 'No especificado';
}

/**
 * Obtiene el nombre del estado del expediente
 */
getEstadoExpedienteName(estadoId: any): string {
  if (!estadoId) return 'No seleccionado';
  const estado = this.estadosExpedientes?.find(e => e.id === estadoId);
  return estado?.descripcion || 'No especificado';
}

/**
 * Obtiene el nombre del estado procesal
 */
getEstadoProcesalName(estadoId: any): string {
  if (!estadoId) return 'No seleccionado';
  const estado = this.estadosProcesal?.find(e => e.id === estadoId);
  return estado?.descripcion || 'No especificado';
}

/**
 * Obtiene un valor del resumen de todos los formularios
 */
getSummaryValue(field: string): any {
  // Buscar en todos los formularios
  let value = this.informacionBasicaForm.get(field)?.value;
  if (value !== null && value !== undefined) return value;

  value = this.detallesExpedienteForm.get(field)?.value;
  if (value !== null && value !== undefined) return value;

  value = this.informacionAdicionalForm.get(field)?.value;
  if (value !== null && value !== undefined) return value;

  value = this.descripcionForm.get(field)?.value;
  if (value !== null && value !== undefined) return value;

  return null;
}


  isFalsy(valor: any): boolean {
    return isFalsy(valor);
  }

  trackByItems(index: number, item: any): any {
    return item;
  }
}
